/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * TabPicker API
 * Pull tabs odds calculator and game management API with comprehensive validation
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  GetApiAuthCallbackParams,
  GetApiAuthGoogleParams,
  LogoutSuccessResponse,
  SessionResponse
} from '.././';

import { customFetch } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get current user session
 */
export const getApiAuthMe = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<SessionResponse>(
      {url: `/api/auth/me`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiAuthMeQueryKey = () => {
    return [`/api/auth/me`] as const;
    }

    
export const getGetApiAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiAuthMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAuthMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthMe>>> = ({ signal }) => getApiAuthMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAuthMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthMe>>>
export type GetApiAuthMeQueryError = unknown


export function useGetApiAuthMe<TData = Awaited<ReturnType<typeof getApiAuthMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAuthMe<TData = Awaited<ReturnType<typeof getApiAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAuthMe<TData = Awaited<ReturnType<typeof getApiAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user session
 */

export function useGetApiAuthMe<TData = Awaited<ReturnType<typeof getApiAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAuthMeQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Redirects user to Google OAuth consent screen
 * @summary Initiate Google OAuth login
 */
export const getApiAuthGoogle = (
    params?: GetApiAuthGoogleParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<unknown>(
      {url: `/api/auth/google`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiAuthGoogleQueryKey = (params?: GetApiAuthGoogleParams,) => {
    return [`/api/auth/google`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiAuthGoogleQueryOptions = <TData = Awaited<ReturnType<typeof getApiAuthGoogle>>, TError = null | ErrorResponse>(params?: GetApiAuthGoogleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGoogle>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAuthGoogleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthGoogle>>> = ({ signal }) => getApiAuthGoogle(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGoogle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAuthGoogleQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthGoogle>>>
export type GetApiAuthGoogleQueryError = null | ErrorResponse


export function useGetApiAuthGoogle<TData = Awaited<ReturnType<typeof getApiAuthGoogle>>, TError = null | ErrorResponse>(
 params: undefined |  GetApiAuthGoogleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGoogle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthGoogle>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthGoogle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAuthGoogle<TData = Awaited<ReturnType<typeof getApiAuthGoogle>>, TError = null | ErrorResponse>(
 params?: GetApiAuthGoogleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGoogle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthGoogle>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthGoogle>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAuthGoogle<TData = Awaited<ReturnType<typeof getApiAuthGoogle>>, TError = null | ErrorResponse>(
 params?: GetApiAuthGoogleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGoogle>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Initiate Google OAuth login
 */

export function useGetApiAuthGoogle<TData = Awaited<ReturnType<typeof getApiAuthGoogle>>, TError = null | ErrorResponse>(
 params?: GetApiAuthGoogleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGoogle>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAuthGoogleQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Processes the OAuth callback from Google and creates user session
 * @summary Handle Google OAuth callback
 */
export const getApiAuthCallback = (
    params: GetApiAuthCallbackParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<unknown>(
      {url: `/api/auth/callback`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiAuthCallbackQueryKey = (params?: GetApiAuthCallbackParams,) => {
    return [`/api/auth/callback`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiAuthCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getApiAuthCallback>>, TError = null | ErrorResponse | ErrorResponse>(params: GetApiAuthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAuthCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthCallback>>> = ({ signal }) => getApiAuthCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAuthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthCallback>>>
export type GetApiAuthCallbackQueryError = null | ErrorResponse | ErrorResponse


export function useGetApiAuthCallback<TData = Awaited<ReturnType<typeof getApiAuthCallback>>, TError = null | ErrorResponse | ErrorResponse>(
 params: GetApiAuthCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAuthCallback<TData = Awaited<ReturnType<typeof getApiAuthCallback>>, TError = null | ErrorResponse | ErrorResponse>(
 params: GetApiAuthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAuthCallback<TData = Awaited<ReturnType<typeof getApiAuthCallback>>, TError = null | ErrorResponse | ErrorResponse>(
 params: GetApiAuthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Handle Google OAuth callback
 */

export function useGetApiAuthCallback<TData = Awaited<ReturnType<typeof getApiAuthCallback>>, TError = null | ErrorResponse | ErrorResponse>(
 params: GetApiAuthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAuthCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Invalidates current session and clears authentication cookies
 * @summary Logout current user
 */
export const postApiAuthLogout = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LogoutSuccessResponse>(
      {url: `/api/auth/logout`, method: 'POST', signal
    },
      options);
    }
  


export const getPostApiAuthLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthLogout>>, TError,void, TContext> => {

const mutationKey = ['postApiAuthLogout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthLogout>>, void> = () => {
          

          return  postApiAuthLogout(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthLogout>>>
    
    export type PostApiAuthLogoutMutationError = unknown

    /**
 * @summary Logout current user
 */
export const usePostApiAuthLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuthLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuthLogout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiAuthLogoutMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    